export default "__VITE_ASSET__CvCNZYpC__"